<template>
<div :class="readOnly ? 'disablebg': ''">
  <PopupDetails
    :readOnly="readOnly"
    :isFirstColumn="isFirstColumn"
    :header="header"
    :details="getDetails"
    :value="getDetails && getDetails[header.column]"
    :material="material"
    :quantity="quantity"
    :weight="weight"
    :mrp="mrp"
    :unit="materialCategory && header.unit && materialCategory[header.unit]"
    :showAmount="showAmount"
    :materialSummary="materialSummary"
    @updateValues="updateValues"
    @updateAmount="updateAmount" />
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { movementMap } from 'pando-constants';
import PopupDetails from './PopupDetails';

export default {
  props: ['header', 'index', 'details', 'material', 'quantity', 'weight', 'materialCategory',
    'readOnly', 'movement', 'isFirstColumn', 'mrp', 'materialSummary'],
  components: {
    PopupDetails,
  },
  computed: {
    ...mapGetters({
      configurations: 'app/configurations',
      tempGrnDetails: 'order/grnDetails',
    }),
    showAmount() {
      const movement = movementMap[this.movement].toLowerCase();
      const paymentStrategies = this.configurations && this.configurations.payment_strategies;
      const sdcdConfig = paymentStrategies && paymentStrategies.movement_based[movement];
      return sdcdConfig[this.header.name] && sdcdConfig[this.header.name].amount_type === 4;
    },
    getDetails() {
      if (this.tempGrnDetails && this.tempGrnDetails[this.index]) {
        return this.tempGrnDetails && this.tempGrnDetails[this.index];
      }
      return this.details;
    },
  },
  methods: {
    updateValues(value) {
      const editedValues = { ...this.getDetails };
      editedValues[this.header.column] = value;
      this.update(editedValues);
      this.$store.commit('order/HAS_WARNED_ONCE', false);
    },
    updateAmount(value) {
      const editedValues = { ...this.getDetails };
      editedValues[this.header.charge] = value;
      this.update(editedValues);
    },
    update(editedValues) {
      const temp = Object.assign(editedValues, { id: this.index });
      delete temp.is_submited;
      // delete temp.comment;
      this.$store.commit('order/ADD_GRN_DETAIL', temp);
    },
  },
};
</script>
